import {IChannelGroup} from './ChannelGroup';
import { ITypeChannelsCollection } from './EpgChannel';
import { ITypeProgramsCollection } from './EpgProgram';
import List from './lib/List';
import { ITypeExpandedGenreMap } from './Model';

export class Utils {
  public static set player(value: any) {
    Utils._player = value;
  }

  public static get player(): any {
    return Utils._player;
  }

  public static get genresMap(): any {
    return Utils._genresMap;
  }

  public static allocateProgramsToChannels(
    programs: ITypeProgramsCollection,
    channels: ITypeChannelsCollection,
  ) {
    if (programs && channels) {
      Object.entries(programs).forEach(([id, program]) => {
        const channel = channels[id as unknown as number];
        channel.setPrograms(
          programs[channel.id].programs,
          programs[channel.id].isExtended,
        );
      });
    }
  }

  public static processGenresMap(map: any) {
    let newMap: any;
    if (Array.isArray(map)) {
      newMap = {};
      for (let i: number = 0, l: number = map.length; i < l; ++i) {
        newMap[map[i].id] = map[i].title;
      }
    } else {
      newMap = map;
    }
    Utils._genresMap = newMap;
  }

  public static translate(key: string, defaultValue: string): string {
    let result = defaultValue || key;
    if (
      Utils._player &&
      Utils._player.config &&
      typeof Utils._player.config.i18n === 'function'
    ) {
      result = Utils._player.config.i18n(key) || defaultValue;
    }
    return result;
  }
  private static _genresMap: any;
  private static _player: any;
}
